import { render, staticRenderFns } from "./LogsWithViewer.vue?vue&type=template&id=0dde26b2&scoped=true&"
import script from "./LogsWithViewer.vue?vue&type=script&lang=js&"
export * from "./LogsWithViewer.vue?vue&type=script&lang=js&"
import style0 from "./LogsWithViewer.vue?vue&type=style&index=0&id=0dde26b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dde26b2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0dde26b2')) {
      api.createRecord('0dde26b2', component.options)
    } else {
      api.reload('0dde26b2', component.options)
    }
    module.hot.accept("./LogsWithViewer.vue?vue&type=template&id=0dde26b2&scoped=true&", function () {
      api.rerender('0dde26b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/logs/LogsWithViewer.vue"
export default component.exports